import {VoidAuditReportModel} from "./void-audit-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-void-audit-report",
    templateUrl: "./void-audit-report.component.html",
    providers: [provideReportModel(VoidAuditReportModel)]
})
export class VoidAuditReportComponent extends AbstractReportPage {

    constructor(public model: VoidAuditReportModel) {
        super();
    }
}
